// Script to add clickable links to specific images and hide elements on specific pages
document.addEventListener('DOMContentLoaded', function() {
  // Function 1: Make LG image clickable
  // Target the specific LG image using the XPath provided
  // Convert to a more reliable CSS selector
  const lgImageTargets = document.querySelectorAll('main > div:nth-of-type(10) div:nth-of-type(3) div div div:nth-of-type(2) div div p img');
  const lgImageContainers = document.querySelectorAll('main > div:nth-of-type(10) div:nth-of-type(3) div div div:nth-of-type(2) div div p');
  
  if (lgImageTargets.length > 0) {
    // For the image itself
    lgImageTargets.forEach(image => {
      image.style.cursor = 'pointer';
      image.addEventListener('click', function(e) {
        e.preventDefault();
        window.location.href = 'https://lcdtvthailand.myshopify.com/collections/lg';
      });
    });
    
    // For the container paragraph
    lgImageContainers.forEach(container => {
      container.style.cursor = 'pointer';
      container.addEventListener('click', function(e) {
        e.preventDefault();
        window.location.href = 'https://lcdtvthailand.myshopify.com/collections/lg';
      });
    });
    
    console.log('LG image link handler attached successfully');
  } else {
    console.log('LG image target not found');
    
    // Alternative method using direct XPath-like path - as a fallback
    setTimeout(function() {
      try {
        const mainElement = document.querySelector('main');
        if (mainElement) {
          const divs = mainElement.children;
          if (divs.length >= 10) {
            const targetDiv = divs[9]; // 10th div (0-indexed)
            if (targetDiv) {
              const nestedDivs = targetDiv.querySelectorAll('div');
              nestedDivs.forEach(div => {
                const images = div.querySelectorAll('p img');
                images.forEach(img => {
                  img.style.cursor = 'pointer';
                  img.parentElement.style.cursor = 'pointer';
                  
                  img.addEventListener('click', function(e) {
                    e.preventDefault();
                    window.location.href = 'https://lcdtvthailand.myshopify.com/collections/lg';
                  });
                  
                  img.parentElement.addEventListener('click', function(e) {
                    e.preventDefault();
                    window.location.href = 'https://lcdtvthailand.myshopify.com/collections/lg';
                  });
                  
                  console.log('Applied click handler to image:', img);
                });
              });
            }
          }
        }
      } catch (error) {
        console.error('Error in fallback method:', error);
      }
    }, 1000); // Wait 1 second for any dynamic content to load
  }
  
  // NOTE: Element hiding for LG collection page has been moved to lg-collection-custom.js
  // to avoid duplicated processing and improve performance
});
